import { Button, Flex } from '@chakra-ui/react'
import { Box } from '@retriever-ui/layout'
import { retriever } from '@retriever-ui/system'

type Props = {
  title: string
  Icon: any
  path: string
  active: boolean
  isLogout?: boolean
}

const MenuItemLogout = ({ title, Icon, path }: Props) => {
  const isActive = window.location.pathname.includes(path)

  return (
    <Flex
      as={Button}
      bg="none"
      _hover={{ backgroundColor: 'transparent' }}
      alignItems="center"
      onClick={() => {
        window.location.href = 'https://housi.com/'
      }}
    >
      <Box
        borderTopLeftRadius="8px"
        borderBottomLeftRadius="8px"
        height="56px"
        width="8px"
        backgroundColor={['none', isActive ? 'primary.400' : 'transparent']}
      />
      <Flex
        backgroundColor={[isActive ? 'black.0' : 'transparent']}
        alignItems="center"
        padding="18px"
        boxShadow={['none', isActive ? '0px 4px 16px -5px #0000001a' : 'none']}
        cursor="pointer"
        minWidth="286px"
        color="black.500"
        height="56px"
      >
        <Box mRight="18px">
          <Icon />
        </Box>

        <retriever.p
          textDecoration="none"
          fontWeight={isActive ? 'bold' : 'initial'}
        >
          {title}
        </retriever.p>
      </Flex>
    </Flex>
  )
}

export default MenuItemLogout
